import React, { useState } from 'react'
import SiteGrid from "../ui/SiteGrid"
import { AppInput, AppSelect, AppTextarea } from "../ui/AppInputs"
import { contactSubjects } from "app/data/generalData"
import AppButton from "../ui/AppButton"
import SquareGrid from "../ui/SquareGrid"
import contactImg from "app/assets/images/contact-img.jpg"
import { isEmptyText, validateEmail } from "app/utils/generalUtils"

export default function Contact() {

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [subject, setSubject] = useState(contactSubjects[0].value)
  const [message, setMessage] = useState('')
  const [nameError, setNameError] = useState('')
  const [emailError, setEmailError] = useState('')
  const [messageError, setMessageError] = useState('')

  const handleValidateForm = () => {
    if(isEmptyText(name)) {
      setNameError('Please enter your name')
    }
    if(!validateEmail(email)) {
      setEmailError('Please enter a valid email address')
    }
    if(isEmptyText(message)) {
      setMessageError('Please enter a message')
    }
    return !isEmptyText(name) && validateEmail(email) && !isEmptyText(message)
  }

  const handleSendMessage = () => {
    if(handleValidateForm()) alert('Message sent successfully!')
  }

  return (
    <div className="contact-section home-section">
      <SiteGrid className="contact-flex">
        <div className="img-container">
          <img src={contactImg} alt="contact" />
        </div>
        <div className="contact-container">
          <h2 className="title">Contact Us</h2>
          <form onSubmit={(e) => e.preventDefault()}>
            <AppInput
              placeholder="Full Name"
              onChange={(e) => {
                setName(e.target.value)
                setNameError('')
              }}
              value={name}
              subtext={<small>{nameError}</small>}
            />
            <AppInput
              placeholder="Email Address"
              onChange={(e) => {
                setEmail(e.target.value)
                setEmailError('')
              }}
              value={email}
              subtext={<small>{emailError}</small>}
            />
            <AppSelect
              options={contactSubjects}
              onChange={(e) => setSubject(e.target.value)}
              value={subject}
            />
            <AppTextarea
              placeholder="Your message..."
              onChange={(e) => {
                setMessage(e.target.value)
                setMessageError('')
              }}
              value={message}
              subtext={<small>{messageError}</small>}
            />
            <AppButton
              label="Send Message"
              onClick={handleSendMessage}
              buttonType="outlineBtn animate"
            />
          </form>
        </div>
      </SiteGrid>
      <div className="rectangle"/>
      <div className="circle circle-1"/>
      <div className="circle circle-2"/>
      <SquareGrid className="square-grid-1"/>
      <SquareGrid className="square-grid-2"/>
    </div>
  )
}
